"use client";

import React, { useState } from "react";
import { Typography, Button, Section } from "@/components/ui";
import Image from "next/image";
import { env } from "@/lib/environment";
import { NewButton } from "../ui/NewButton";
import Link from "next/link";

interface PartnerFormProps {
  title: string;
  description: string;
  defaultCategory?: string;
}

const categories = [
  "Reseller",
  "White Label Partner",
  "Hardware Manufacturer",
  "Technology Partner",
  "Service & Solution Provider",
  "Referral Partner",
  "Affiliate Marketer",
];

export default function PartnerForm({ title, description, defaultCategory }: PartnerFormProps) {
  const [formData, setFormData] = useState({
    category: defaultCategory || "",
    fullName: "",
    companyName: "",
    email: "",
    contactNo: "",
    description: "",
  });

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission logic here
    console.log("Form submitted:", formData);
  };

  return (
    <Section id="partnerForm" background="gray">
      <div className="grid md:grid-cols-2 gap-12 items-start">
        {/* Left Column - Content */}
        <div className="h-full flex flex-col justify-center">
          <Typography variant="h2" className="mb-6">
            {title}
          </Typography>
          <Typography variant="body" className="text-gray-600">
            {description}
          </Typography>
          <Link href="/company/contact" className="mt-10">
            <NewButton arrow="grow" variant="primary">Get in Touch with an Expert</NewButton>
          </Link>
        </div>

        {/* Right Column - Form */}

        <div className="w-full">
          <Image
            src={`${env.NEXT_PUBLIC_CDN_URL}/images/partners/partner-cta.N-fwZ_eXe79H.png`}
            alt="capterra review"
            title="capterra"
            width={500}
            height={500}
            className="w-full"
          />
        </div>

        {/* <div>
            <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Typography variant="body" className="font-semibold mb-2">
                Please select the category of partnership you are interested in *
              </Typography>
              <select
                name="category"
                value={formData.category}
                onChange={handleInputChange}
                required
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
              >
                <option value="">-Select-</option>
                {categories.map((category, index) => (
                  <option key={index} value={category}>
                    {category}
                  </option>
                ))}
              </select>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <Typography variant="body" className="font-semibold mb-2">
                  Full Name *
                </Typography>
                <input
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleInputChange}
                  required
                  aria-label="Full Name"
                  className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                />
              </div>

              <div>
                <Typography variant="body" className="font-semibold mb-2">
                  Company Name *
                </Typography>
                <input
                  type="text"
                  name="companyName"
                  value={formData.companyName}
                  onChange={handleInputChange}
                  required
                  aria-label="Company Name"
                  className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <Typography variant="body" className="font-semibold mb-2">
                  Email *
                </Typography>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  aria-label="Email"
                  className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                />
              </div>

              <div>
                <Typography variant="body" className="font-semibold mb-2">
                  Contact No *
                </Typography>
                <input
                  type="tel"
                  name="contactNo"
                  value={formData.contactNo}
                  onChange={handleInputChange}
                  required
                  aria-label="Contact No"
                  className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                />
              </div>
            </div>

            <div>
              <Typography variant="body" className="font-semibold mb-2">
                Description
              </Typography>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                rows={4}
                aria-label="Description"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent resize-none"
              />
            </div>

            <div className="text-center">
              <Button type="submit" variant="primary" className="bg-red-600 hover:bg-red-700 text-white px-8 py-3 rounded-lg font-semibold">
                Submit
              </Button>
            </div>
            </form>
          </div> */}
      </div>
    </Section>
  );
}
